/**
 * Implement toggle functionality for Accordion Component
 *
 * @return void
 * @since  1.0.0
 * @access public
 */

import {getClosest} from './helpers';

export const accordion = () => {
	const accordionToggle = document.querySelectorAll( '.js-accordion-toggle' );

	accordionToggle.forEach( function ( element, index ) {
		element.addEventListener( 'click', function ( event ) {
			event.preventDefault();
			const parent            = element.parentNode;
			const dataId            = element.getAttribute( 'data-id' );
			const mainParent        = getClosest( event.target, '.c-toggle' );
			const toggleImage       = '.c-toggle__image';
			const toggleItems       = document.querySelectorAll( '.c-toggle__item' );
			const activeToggleClass = 'c-toggle__item--open';
			const activeImageClass  = 'c-toggle__image--active';

			// Loop over all toggle images and remove the active class
			mainParent.querySelectorAll( toggleImage ).forEach( node => node.classList.remove( activeImageClass ) );

			// The get the current toggle item ID and select the respective toggle image and show it
			mainParent.querySelector( '.c-toggle__images [data-id="' + dataId + '"]' ).classList.add( activeImageClass );

			// Check if the current item contains the active class
			if ( parent.classList.contains( activeToggleClass ) ) {
				toggleItems.forEach( node => {
					node.classList.remove( activeToggleClass );
					node.setAttribute( 'aria-expanded', 'false' );
				} );
				parent.classList.remove( activeToggleClass );
				parent.setAttribute( 'aria-expanded', 'false' );
				// Else if current item does not contain the active class
			} else {
				toggleItems.forEach( node => {
					node.classList.remove( activeToggleClass );
					node.setAttribute( 'aria-expanded', 'false' );
				} );
				parent.classList.add( activeToggleClass );
				parent.setAttribute( 'aria-expanded', 'true' );
			}

		} );
	} );
}
